import React from 'react'
import SEO from "../shared/seo"
import Layout from '../components/organisms/layout/layout'
import { ReferenciaContenido } from '../interfaces/ReferenciaContenido'
import LibraryComponents from '../components/templates/library-components/libraryComponents';
import Loading from "../components/atoms/loading/loading";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const TemplateTwo = (props:any) => {

   const keyName = props.pageContext.referenciaCabecera && props.pageContext.referenciaCabecera.tipoCabecera
   const pageSlug = props.location.pathname

   return (
      <Layout
         hideHeaderDesktop={true}
         hideHeaderMobile={true}
         isNotRoot={props.pageContext.noRoot !== true ? true : false} 
         headboard={props.pageContext.referenciaCabecera ? props.pageContext.referenciaCabecera : ""}
         typeChat={props.pageContext.tipoChat} 
         menuEspecifico={props.pageContext.menuEspecifico} 
         esconderLoggin={props.pageContext.esconderLoggin} 
      >
         <SEO
            title={props.pageContext.metaTitulo || props.pageContext.nombreCategoria}
            slug={pageSlug}
            description={ props.pageContext.metaDescripcion && documentToReactComponents(JSON.parse(props.pageContext.metaDescripcion.raw)) } 
            image={ props.pageContext.referenciaCabecera.imagenHeader && props.pageContext.referenciaCabecera.imagenHeader.file.url } 
            lang={ "es" } 
            noCanonical={ props.pageContext.noCanonical } 
            urlCanonical={ props.pageContext.urlCanonical } 
            noIndex={ props.pageContext.noIndex }
            fbId={process.env.GATSBY_FACEBOOK_APP_ID_HOME}
         /> 
         {props.pageContext.referenciaContenido ? props.pageContext.referenciaContenido.map (
            (value:ReferenciaContenido, index:number) => (
               <div key={index} className={keyName} id={`${keyName}${index}`} >
                  <LibraryComponents
                     content={value} 
                     categoryName={props.pageContext.nombreCategoria}  
                  /> 
               </div>
            ))
            :
            <Loading />
         }
      </Layout>
   )
}

export default TemplateTwo;
